import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleListComponent } from './sale-list.component';
import { SaleItemComponentModule } from './sale-item/sale-item.module';
import { SharedModule } from '../../shared.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {TableModule} from "primeng/table";
import {ButtonModule} from "primeng/button"

import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    SharedModule,
    NgxDatatableModule,
    ButtonModule,
    TableModule,
    RouterModule,
    SaleItemComponentModule
  ],
  declarations: [SaleListComponent],
  exports: [SaleListComponent],
})
export class SaleListComponentModule {}
